import { render } from "./VacanciesView.vue?vue&type=template&id=b24f756a&scoped=true"
import script from "./VacanciesView.vue?vue&type=script&lang=js"
export * from "./VacanciesView.vue?vue&type=script&lang=js"

import "./VacanciesView.vue?vue&type=style&index=0&id=b24f756a&scoped=true&lang=css"
import "./VacanciesView.vue?vue&type=style&index=1&id=b24f756a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b24f756a"]])

export default __exports__